"use client";

import { c as _c } from "react/compiler-runtime";
import TiptapEditor from "../tiptap/editor";
import { InsertVariableButton } from "../tiptap/insert-variable-button";
import type { Editor } from "@tiptap/core";
import { useCallback, useMemo, useState } from "react";
import { Label } from "@/components/ui/label";
import { hydrateSmsTemplateFromSuggestions, smsExtraTemplateSuggestions } from "@/lib/sms-templates";
import { useCarePlanContext } from "./care-plan";
import { StepType } from "./types";
import { streamSMSTemplate } from "@/api/ai/sms";
import { useSuggestions } from "@/api/query/provider/suggestions";
export function MessageStepDetail() {
  const $ = _c(23);
  const {
    state: t0,
    actions: t1,
    config: t2,
    lookups: t3
  } = useCarePlanContext();
  const {
    selectedStep
  } = t0;
  const {
    updateStep
  } = t1;
  const {
    readOnly
  } = t2;
  const {
    patientId
  } = t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["PATIENT", "TENANT", "EVENT"];
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const {
    data: t5
  } = useSuggestions(t4, patientId);
  let t6;
  if ($[1] !== t5) {
    t6 = t5 === undefined ? [] : t5;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const apiSuggestions = t6;
  let t7;
  if ($[3] !== apiSuggestions) {
    t7 = [...apiSuggestions, ...smsExtraTemplateSuggestions];
    $[3] = apiSuggestions;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const suggestions = t7;
  const [editor, setEditor] = useState(null);
  let t8;
  if ($[5] !== selectedStep || $[6] !== updateStep) {
    t8 = updates => {
      if (selectedStep) {
        updateStep(selectedStep.id, updates);
      }
    };
    $[5] = selectedStep;
    $[6] = updateStep;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const update = t8;
  const generateAI = _temp;
  if (!selectedStep || selectedStep.type !== StepType.MESSAGE) {
    return null;
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Label>Message Body</Label>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== editor || $[10] !== readOnly || $[11] !== suggestions) {
    t10 = !readOnly && <InsertVariableButton editor={editor} suggestions={suggestions} posthogSurface="care_plan" />;
    $[9] = editor;
    $[10] = readOnly;
    $[11] = suggestions;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = <div className="flex items-center justify-between">{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== readOnly || $[16] !== selectedStep.smsBody || $[17] !== suggestions || $[18] !== update) {
    t12 = readOnly ? <p className="text-body text-foreground-secondary whitespace-pre-wrap rounded-md border border-border bg-background-secondary p-3">{selectedStep.smsBody ? hydrateSmsTemplateFromSuggestions(selectedStep.smsBody, suggestions) : "No message content"}</p> : <TiptapEditor content={selectedStep.smsBody || ""} onUpdate={text => update({
      smsBody: text
    })} suggestions={suggestions} placeholder="Type message... use @ to insert variables" onGenerateAI={generateAI} parentClassName="mt-1" editorClassName="min-h-[120px]" onEditorReady={setEditor} />;
    $[15] = readOnly;
    $[16] = selectedStep.smsBody;
    $[17] = suggestions;
    $[18] = update;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <div className="space-y-1">{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}
function _temp(currentValue, feedback, previousGeneration) {
  return streamSMSTemplate({
    serviceName: "Care Plan Message",
    templateType: "followUp",
    currentTemplate: currentValue || undefined,
    feedback: feedback || undefined,
    previousGeneration: previousGeneration || undefined
  });
}